import React, { useState } from 'react';
import activateArrow from '../../../../assets/images/login/activateArrow.png';
import { oneDineLogo } from '../../../../assets/images';
import backImg from '../../../../assets/images/Fireboard/back2_red.png';
import styles from './PairWatch.module.css';

const PairWatch = (props) => {
  const { loginInfo, dismissPopup, doPairWatch } = props;
  const [fieldValue, setFieldValue] = useState('');

  const onPress = () => {
    if (fieldValue.length === 0) return;
    doPairWatch && doPairWatch(fieldValue);
    setFieldValue('');
  };

  const onSubmit = e => {
    e.preventDefault();
    onPress();
  };

  const heading = loginInfo ? 'Please enter the 6-digit code from the watch' : 'Please enter the employee code';

  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <div className={styles.backButton} onClick={dismissPopup}>
          <img src={backImg} className={styles.backImage} alt="" />
        </div>
        <img src={oneDineLogo} className={styles.logo} alt="logo" />
        <div className={styles.wrapper}>
          <div className={styles.heading}>{heading}</div>
        </div>
        <div className={styles.btnWrapper}>
          <form onSubmit={onSubmit}>
            <input type="text" placeholder="" value={fieldValue} onChange={event => setFieldValue(event.target.value)} className={styles.textInput} />
          </form>
          <button type="submit" onClick={onPress}>
            <img src={activateArrow} className={styles.activate} alt="activateArrow" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default PairWatch;
